// src/components/AccountCreation/constants.js

export const PLANS_CONFIG = {
  'US/Canada': {
    'iOS': {
      'Bronze': { monthly: 12, quarterly: 30, annual: 110 },
      'Gold': { monthly: 22, quarterly: 60, annual: 220 },
    },
    'Android': {
      'Bronze': { monthly: 10, quarterly: 25, annual: 90 },
      'Premium': { monthly: 30, quarterly: 75, annual: 270 },
    }
  },
  'International': {
    'iOS': {
      'Bronze': { monthly: 15, quarterly: 40, annual: 150 },
      'Premium': { monthly: 35, quarterly: 90, annual: 350 },
    },
    'Android': {
      'Gold': { monthly: 25, quarterly: 70, annual: 250 },
      'Premium': { monthly: 32, quarterly: 85, annual: 320 },
    }
  }
};

export const MOCK_CORRECT_OTP = "123456";
